import { GET_DASHBOARD_GRAPH_DETAILS_FAILURE, GET_DASHBOARD_GRAPH_DETAILS_SUCCESS } from '../constants/MTag';
import { onFailure, onSuccess } from './common';

const initStat = { data: [], error: false, errorData: '', isLoading: true };

export default (state = initStat, action) => {
	switch (action.type) {
		case GET_DASHBOARD_GRAPH_DETAILS_SUCCESS:
			return onSuccess(state, action);
		case GET_DASHBOARD_GRAPH_DETAILS_FAILURE:
			return onFailure(state, action);
		default:
			return { ...state };
	}
};
